"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorStatusMap = exports.ErrorCode = void 0;
// Error codes used across the application
var ErrorCode;
(function (ErrorCode) {
    // Validation Errors (400)
    ErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ErrorCode["INVALID_INPUT"] = "INVALID_INPUT";
    ErrorCode["MISSING_REQUIRED_FIELD"] = "MISSING_REQUIRED_FIELD";
    ErrorCode["INVALID_REQUEST_FORMAT"] = "INVALID_REQUEST_FORMAT";
    ErrorCode["BAD_REQUEST"] = "BAD_REQUEST";
    // Authentication Errors (401)
    ErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
    ErrorCode["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
    ErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ErrorCode["INVALID_OTP"] = "INVALID_OTP";
    // Authorization Errors (403)
    ErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ErrorCode["INSUFFICIENT_PERMISSIONS"] = "INSUFFICIENT_PERMISSIONS";
    ErrorCode["USER_DISABLED"] = "USER_DISABLED";
    ErrorCode["ACCOUNT_DISABLED"] = "ACCOUNT_DISABLED";
    // Not Found Errors (404)
    ErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    ErrorCode["COUPON_NOT_FOUND"] = "COUPON_NOT_FOUND";
    ErrorCode["MERCHANT_NOT_FOUND"] = "MERCHANT_NOT_FOUND";
    ErrorCode["RESOURCE_NOT_FOUND"] = "RESOURCE_NOT_FOUND";
    // Gone Errors (410)
    ErrorCode["GONE"] = "GONE";
    // Conflict Errors (409)
    ErrorCode["CONFLICT"] = "CONFLICT";
    ErrorCode["DUPLICATE_ENTRY"] = "DUPLICATE_ENTRY";
    ErrorCode["RESOURCE_ALREADY_EXISTS"] = "RESOURCE_ALREADY_EXISTS";
    ErrorCode["DUPLICATE_RESOURCE"] = "DUPLICATE_RESOURCE";
    ErrorCode["COUPON_ALREADY_USED"] = "COUPON_ALREADY_USED";
    ErrorCode["COUPON_EXPIRED"] = "COUPON_EXPIRED";
    ErrorCode["EXPIRED"] = "EXPIRED";
    ErrorCode["BUSINESS_ERROR"] = "BUSINESS_ERROR";
    // Rate Limiting (429)
    ErrorCode["RATE_LIMITED"] = "RATE_LIMITED";
    ErrorCode["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    ErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
    // Server Errors (500)
    ErrorCode["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ErrorCode["DATABASE_ERROR"] = "DATABASE_ERROR";
    ErrorCode["EXTERNAL_SERVICE_ERROR"] = "EXTERNAL_SERVICE_ERROR";
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
// HTTP status code mapping
exports.ErrorStatusMap = {
    // 400 errors
    [ErrorCode.VALIDATION_ERROR]: 400,
    [ErrorCode.INVALID_INPUT]: 400,
    [ErrorCode.MISSING_REQUIRED_FIELD]: 400,
    [ErrorCode.INVALID_REQUEST_FORMAT]: 400,
    [ErrorCode.BAD_REQUEST]: 400,
    // 401 errors
    [ErrorCode.UNAUTHORIZED]: 401,
    [ErrorCode.INVALID_TOKEN]: 401,
    [ErrorCode.TOKEN_EXPIRED]: 401,
    [ErrorCode.INVALID_CREDENTIALS]: 401,
    [ErrorCode.INVALID_OTP]: 401,
    // 403 errors
    [ErrorCode.FORBIDDEN]: 403,
    [ErrorCode.INSUFFICIENT_PERMISSIONS]: 403,
    [ErrorCode.USER_DISABLED]: 403,
    [ErrorCode.ACCOUNT_DISABLED]: 403,
    // 404 errors
    [ErrorCode.NOT_FOUND]: 404,
    [ErrorCode.USER_NOT_FOUND]: 404,
    [ErrorCode.COUPON_NOT_FOUND]: 404,
    [ErrorCode.MERCHANT_NOT_FOUND]: 404,
    [ErrorCode.RESOURCE_NOT_FOUND]: 404,
    // 410 errors
    [ErrorCode.GONE]: 410,
    // 409 errors
    [ErrorCode.CONFLICT]: 409,
    [ErrorCode.DUPLICATE_ENTRY]: 409,
    [ErrorCode.RESOURCE_ALREADY_EXISTS]: 409,
    [ErrorCode.DUPLICATE_RESOURCE]: 409,
    [ErrorCode.COUPON_ALREADY_USED]: 409,
    [ErrorCode.COUPON_EXPIRED]: 409,
    [ErrorCode.EXPIRED]: 409,
    [ErrorCode.BUSINESS_ERROR]: 409,
    // 429 errors
    [ErrorCode.RATE_LIMITED]: 429,
    [ErrorCode.TOO_MANY_REQUESTS]: 429,
    [ErrorCode.RATE_LIMIT_EXCEEDED]: 429,
    // 500 errors
    [ErrorCode.INTERNAL_SERVER_ERROR]: 500,
    [ErrorCode.DATABASE_ERROR]: 500,
    [ErrorCode.EXTERNAL_SERVICE_ERROR]: 500,
    [ErrorCode.NOT_IMPLEMENTED]: 501,
};
